// The official page of a Parliament document, presentational: a button that
// shows and hides it, and the page itself in a sandboxed frame (no script,
// no form, an opaque origin: the api serves it with a Content-Security-Policy
// without scripts as well), at the anchor of the entry «vai al punto» last
// went to (the Camera's pages carry ids). Every element is one the design
// already has:
//   button   the status button, PanelStatus.tsx:4-5 (STATUS_BUTTON_CLASS), as the file row's «Apri»
//   row      ROW_CLASS, NewsReader.tsx:100
// No mockup for the frame: 70vh tall, no border, the width of the text.
import { Button } from "@heroui/react";
import { useId } from "react";

import { ROW_CLASS } from "../news/NewsReader";
import { STATUS_BUTTON_CLASS } from "../PanelStatus";

export const OPEN_OFFICIAL = "Apri la pagina ufficiale";
export const CLOSE_OFFICIAL = "Chiudi la pagina ufficiale";
export const OFFICIAL_TITLE = "Pagina ufficiale";

type OfficialPageProps = {
  /** The api's route of the page. */
  src: string;
  /** The id in the page to land on; null for its top. */
  anchor: string | null;
  open: boolean;
  onToggle: () => void;
};

export function OfficialPage({ src, anchor, open, onToggle }: OfficialPageProps) {
  const frameId = useId();
  return (
    <div className="flex flex-col gap-2">
      <div className={`flex items-center justify-between gap-2.5 ${ROW_CLASS}`}>
        <span>{OFFICIAL_TITLE}</span>
        <Button
          size="sm"
          onPress={onToggle}
          aria-expanded={open}
          aria-controls={open ? frameId : undefined}
          className={STATUS_BUTTON_CLASS}
        >
          {open ? CLOSE_OFFICIAL : OPEN_OFFICIAL}
        </Button>
      </div>
      {open && (
        <iframe
          id={frameId}
          title={OFFICIAL_TITLE}
          sandbox=""
          src={anchor ? `${src}#${anchor}` : src}
          className="h-[70vh] w-full border-0"
        />
      )}
    </div>
  );
}
